//#region src/components/Tree/Tree.module.css
var e = "_tree_8kr0p_1", t = "_loading_8kr0p_8", n = "_items_8kr0p_12", r = "_item_8kr0p_12", i = {
	tree: e,
	loading: t,
	items: n,
	item: r
};
//#endregion
export { i as default, r as item, n as items, t as loading, e as tree };
